import axiosInstance from "../Interceptor";

export const getCustomerProfileApi = (payload) => {
  // console.log(payload);

  return axiosInstance
    .get(`user-service/api/v1/customer/${payload}/`)

    .then((response) => {
      if (response.status === 200) {
        return response;
      }
      // return response
    })
    .catch((error) => {
      return error;
    });
};
